import {BrowserRouter, Routes, Route  } from 'react-router-dom'
import "bootstrap/dist/css/bootstrap.min.css"
import "react-bootstrap"
import Login from './Pages/others/Login'
import Home from './Pages/others/Home'
import Registration from './Pages/reg/Doc_Reg'
import RegistrationEc from './Pages/reg/Ec_Reg'
import { Client } from './Pages/client/client'
import Mydoc from './Pages/my/mydoc'
import { ProtectedRoute } from './route'
import { Admin } from './Pages/admin/admin'
import RegistrationNl from './Pages/reg/nagel_Reg'
import MyEc from './Pages/my/my_ec'
import MyNl from './Pages/my/my_doc'
import DashBoardM from './Pages/dashboard/mainDashboard'
import { Datacontext } from './context/dataContext'
import { useContext, useEffect } from 'react'
import PrintLabelDocument from './Pages/print/PrintLabelDocument'
import HowToDo from './Pages/others/HowToDo'

const App = () => {
  const { initData } = useContext(Datacontext);

  useEffect(() => {
    const initialize = async () => {
      try {
        await initData();
      } catch (error) {
        console.error("Initialization failed:", error);
      }
    };

    initialize();
  }, [initData]);

  return (
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Login/>} />
      <Route path='/dashboard' element={<ProtectedRoute allowedRoles={["admin","user"]}><DashBoardM/></ProtectedRoute>} />
      <Route path='/home' element={<ProtectedRoute allowedRoles={["admin","user"]}><Home /></ProtectedRoute>} />
      <Route path='/login' element={<Login/>} />
      <Route path='/register' element={<ProtectedRoute allowedRoles={["admin","user"]}><Registration/></ProtectedRoute>} />
      <Route path='/client' element={<ProtectedRoute allowedRoles={["admin","user"]}><Client/></ProtectedRoute>}/>
      <Route path='/mydoc' element={<ProtectedRoute allowedRoles={["admin","user"]}><Mydoc/></ProtectedRoute>} />
      <Route path='/myec' element={<ProtectedRoute allowedRoles={["admin","user"]}><MyEc/></ProtectedRoute>} />
      <Route path='/mynl' element={<ProtectedRoute allowedRoles={["admin","user"]}><MyNl/></ProtectedRoute>} />
      <Route path='/admin' element={<ProtectedRoute allowedRoles={["admin"]}><Admin/></ProtectedRoute>} />
      <Route path='/ec_register' element={<ProtectedRoute allowedRoles={["admin","user"]}><RegistrationEc/></ProtectedRoute>} />
      <Route path='/nl_register' element={<ProtectedRoute allowedRoles={["admin","user"]}><RegistrationNl/></ProtectedRoute>} />
      <Route path='/print-label' element={<ProtectedRoute allowedRoles={["admin","user"]}><PrintLabelDocument/></ProtectedRoute>} />
      <Route path='/how-to-do' element={<HowToDo/>} />
    </Routes>
    </BrowserRouter>
  )
}

export default App